import httpRequest from 'httpRequest'
import { PaymentSettingContract, PaymentSettingLookupContract } from 'models'

const PAYMENT_SETTING_PREFIX = '/location/system-payment-settings'

const paymentSettingService = {
    getCurrentLocationPaymentSettings: () =>
        httpRequest.get<PaymentSettingLookupContract[]>(
            `${PAYMENT_SETTING_PREFIX}/current-location`,
        ),
    putActivePayment: (paymentTypeId: number, isActive: boolean) =>
        httpRequest.put(
            `${PAYMENT_SETTING_PREFIX}/${paymentTypeId}/set-active`,
            {},
            { params: { isActive } },
        ),

    getSystemPaymentById: (paymentTypeId: number) =>
        httpRequest.get<PaymentSettingContract>(
            `${PAYMENT_SETTING_PREFIX}/${paymentTypeId}`,
        ),
}

export default paymentSettingService
